import { render, staticRenderFns } from "./LgMudarDepartamentoModal.vue?vue&type=template&id=023c7f30&scoped=true"
import script from "./LgMudarDepartamentoModal.vue?vue&type=script&lang=js"
export * from "./LgMudarDepartamentoModal.vue?vue&type=script&lang=js"
import style0 from "./LgMudarDepartamentoModal.vue?vue&type=style&index=0&id=023c7f30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023c7f30",
  null
  
)

export default component.exports